import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';

@Injectable()
export class TranslocoMatPaginatorIntl extends MatPaginatorIntl {
  private transloco = inject(TranslocoService);
  private destroyRef = inject(DestroyRef);

  constructor() {
    super();
    this.translateLabels();
    this.transloco.langChanges$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.translateLabels();
        this.changes.next();
      });
  }

  override getRangeLabel = (
    page: number,
    pageSize: number,
    length: number
  ): string => {
    if (length === 0 || pageSize === 0) {
      return this.transloco.translate('COMMON.PAGINATOR.RANGE_EMPTY', {
        length,
      });
    }
    const safeLength = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < safeLength
        ? Math.min(startIndex + pageSize, safeLength)
        : startIndex + pageSize;
    return this.transloco.translate('COMMON.PAGINATOR.RANGE', {
      start: startIndex + 1,
      end: endIndex,
      length: safeLength,
    });
  };

  private translateLabels() {
    this.itemsPerPageLabel = this.transloco.translate(
      'COMMON.PAGINATOR.ITEMS_PER_PAGE'
    );
    this.nextPageLabel = this.transloco.translate(
      'COMMON.PAGINATOR.NEXT_PAGE'
    );
    this.previousPageLabel = this.transloco.translate(
      'COMMON.PAGINATOR.PREVIOUS_PAGE'
    );
    this.firstPageLabel = this.transloco.translate(
      'COMMON.PAGINATOR.FIRST_PAGE'
    );
    this.lastPageLabel = this.transloco.translate(
      'COMMON.PAGINATOR.LAST_PAGE'
    );
  }
}
